import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  aplicacaoList: [],
};

const aplicacaoSlice = createSlice({
  name: "aplicacoes",
  initialState,
  reducers: {
    saveAplicacao: (state, action) => {
      state.aplicacaoList.push(action.payload);
    },
  },
});

// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.
export const getAplicacaoById = (id) => (state) =>
  state.aplicacoes.aplicacaoList.find((i) => i.id === id);

export const getAllAplicacoes = (state) => state.aplicacoes.aplicacaoList;

export const { saveAplicacao } = aplicacaoSlice.actions;
export default aplicacaoSlice.reducer;
